import { render } from "./MenuIcon.vue?vue&type=template&id=807e043c&scoped=true"
import script from "./MenuIcon.vue?vue&type=script&lang=js"
export * from "./MenuIcon.vue?vue&type=script&lang=js"

import "./MenuIcon.vue?vue&type=style&index=0&id=807e043c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-807e043c"

export default script